export default __webpack_public_path__ + "static/media/alaska.57f03d5a.svg";